import { SVG } from '../../../components/SVG';
import { useHistoryMethod } from '../../../utils/hook/useHistoryMethod';
import { usePathnameMethod } from '../../../utils/hook/usePathnameMethod';

const LogoButton = () => {
  const history = useHistoryMethod();
  const { pathname } = usePathnameMethod();

  const onClickMainPage = () => {
    if (pathname === '/main') return;

    history.push('/main');
  };

  return (
    <button onClick={onClickMainPage} type="button">
      <SVG.Logo />
    </button>
  );
};

export default LogoButton;
